module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_SKU2.0025.png.12993a26.jpg";